module.exports = __webpack_public_path__ + "img/lazr-small.d179066d.jpg";